import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from 'context/AuthContext';
import { store } from 'store';
import { Provider } from 'react-redux';
import Snackbar from 'components/Snackbar';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from 'styles/theme';
import { applyHighchartsTheme } from 'styles/highchartsTheme';

applyHighchartsTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <App />
        </AuthProvider>
        <Snackbar />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
